<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('AGUARDANDO_MANIFESTACAO'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      configuracaoFiltro: {},
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Dias', propriedade: 'dias', ordem: 5, acoes: [], exibir: this.showColunaDias },
        {
          id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Analisar Processo', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showAnalisarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Validar Processo', icone: 'fa-check', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showValidarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 3, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showVisualizarProcesso },
            { id: 4, nome: 'Emitir DAE', icone: 'fa-file-invoice-dollar', codigo: 'EMITIR_DAE', ordem: 1, show: this.showEmitirDae },
            { id: 5, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showTrocarAtendente },
            { id: 13, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showTrocarAnalista },
            { id: 8, nome: 'Emitir Título', icone: 'fa-file-contract', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showEmitirTitulo },
            { id: 9, nome: 'Emitir Certidão', icone: 'fa-file-contract', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showEmitirCertidao },
            { id: 12, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showVincularAnalista },
            { id: 14, nome: 'Avocar Processo', icone: 'fa-file', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showAvocarProcesso },
            { id: 16, nome: 'Atualizar Base', icone: 'fa-sync', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showAtualizacaoBase },
            { id: 18, nome: 'Revisar Análise', icone: 'fa-edit', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showRevisarAnalise },
            { id: 21, nome: 'Emitir Portaria', icone: 'fa-file', codigo: 'CONTINUAR_ANALISE', ordem: 1, show: this.showEmitirPortaria }
          ]
        }
      ],
      usuario: null,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.init()
    this.usuario = await this.usuarioLogado
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    })
  },
  methods: {
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAguardandoManifestacao.vue